import { Box, Button, Grid, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { UpdateApproverEmpRegularizationMappingAction } from "../../../../../../store/Leave/Regularization/Action";

const RegularizationActionPopUp = ({ closeMode, editedRecord }) => {
  const initialState = {
    comment: "",
  };
  const dispatch = useDispatch();

  const [regularizationData, setRegularizationData] = useState(initialState);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setRegularizationData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (actionStatus) => {
    if (editedRecord?.attendance_regularisation_pk) {
      dispatch(
        UpdateApproverEmpRegularizationMappingAction({
          attendance_regularisation_pk:
            editedRecord?.attendance_regularisation_pk,
          status: actionStatus,
          comment: regularizationData?.comment || null,
          employee_fk: regularizationData?.employee_id,
        }),
      );
    }
    closeMode();
  };

  useEffect(() => {
    setRegularizationData({
      ...initialState,
      ...editedRecord,
      comment: editedRecord?.comments || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedRecord]);

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <TextField
            fullWidth
            name="comment"
            label="Comment"
            size="small"
            multiline
            minRows={3}
            value={regularizationData?.comment || ""}
            onChange={handleInput}
          />
        </Grid>
      </Grid>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", m: 1.5, mt: 2 }}
      >
        <Button
          className="mpl-primary-btn"
          variant="outlined"
          color="primary"
          size="medium"
          onClick={closeMode}
        >
          Cancel
        </Button>
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <Button
            className="mpl-primary-btn"
            variant="contained"
            size="medium"
            onClick={() => handleSubmit("Rejected")}
          >
            Reject
          </Button>
          <Button
            className="mpl-primary-btn"
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => handleSubmit("Approved")}
          >
            Approve
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default RegularizationActionPopUp;
